import Base from './containers/Base';
export const routes = [
	{
		path: '/baseInformation',
		exact: true,
		component: Base,
		name: 'Base',
	},
];